<template>
    <div class="text-card w-full h-full flex flex-col">
        <div class="max-w-[800px]">
            <template v-if="getData?.headline">
                <component
                    :is="headlineTag"
                    :class="headlineClasses"
                >
                    {{ getData?.headline }}
                </component>
            </template>

            <div v-if="getData?.subHeadline" class="font-semibold text-lg text-link">
                {{ getData?.subHeadline }}
            </div>

            <div
                v-if="getData?.text"
                class="prose max-w-none prose-headings:text-link prose-headings:font-semibold text-lg"
                v-html="getData?.text"
            />

            <template v-if="getConfig?.link?.value">
                <MiscLink
                    v-show="!getConfig?.isHeroBanner?.value"
                    class="block mt-auto pt-6"
                    :to="getConfig?.link?.value"
                >
                    <div class="btn flex items-center w-fit justify-start text-lg font-semibold btn-primary">
                        {{ content.data?.buttonText }}
                        <MiscIcon name="chevron-right" size="lg"/>
                    </div>
                </MiscLink>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import type {HblSlot} from '@/utils/types'
import {computed} from "vue";

const props = defineProps<{
    content: HblSlot
}>()

const getConfig = computed(() => {
    return props?.content?.config
})

const getData = computed( () => {
    return props.content?.data ? props.content?.data : props.content
})

const headlineTag = computed(() =>
    getConfig?.value?.headlineStyle?.value || 'h2'
)

const headlineStyleMap = {
    h1: 'text-4xl',
    h2: 'text-3xl',
    h3: 'text-2xl',
    h4: 'text-xl',
    h5: 'text-lg',
    h6: 'text-base'
}

const headlineClasses = computed(() => {
    const baseClasses = 'text-link pb-4'
    const heroBannerClasses = getConfig?.value?.isHeroBanner?.value
        ? 'font-decorative font-light text-5xl pt-6 pb-3 md:text-6xl xl:text-8xl'
        : headlineStyleMap[headlineTag.value] || 'text-3xl leading-8'

    return `${baseClasses} ${heroBannerClasses}`
})
</script>
